export const WINDOW = 'window'
export const MOBILE_NAV = 'mobile_nav'
export const PRODUCT_CATEGORY = 'product_category'
